type IParserCuit = (cuit: string | number) => number;

export const parserCuit: IParserCuit = (cuit: string | number): number => {
    let cuitParsed: number = 0;

    if (typeof cuit === 'number') {
        cuitParsed = Number(cuit.toString().split('-').join(''));
    } else {
        cuitParsed = Number(cuit.split('-').join(''));
    }

    return cuitParsed;
};
